import {Component, Inject, OnInit} from '@angular/core';
import {AuditItemsTemplateFilters} from "./audit-items-template-filter.interface";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-audit-items-template-filter',
  templateUrl: './audit-items-template-filter.component.html',
  styleUrls: ['./audit-items-template-filter.component.scss']
})
export class AuditItemsTemplateFilterComponent implements OnInit {

  filters: AuditItemsTemplateFilters = {
    section: '',
    sections: []
  } as AuditItemsTemplateFilters;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AuditItemsTemplateFilterComponent>
  ) { }

  ngOnInit(): void {
    this.filters.section = this.data['section'];
    this.filters.sections = this.data['sections'];
  }

  /**
   * Clears the filter data and closes the window.
   *
   * @return {void}
   */
  onClearAndClose(): void {
    // Clear the data.
    this.filters.section = '';
    this.filters.sections = [];
    // Save and close.
    this.onSaveAndClose();
  }

  /**
   * Saves the updated filters and closes the dialog.
   *
   * @return {void}
   */
  onSaveAndClose(): void {
    this.dialogRef.close(this.filters);
  }

}
